import { $createTextNode, $getRoot, createEditor } from 'lexical';

import { TrackingLinkNode } from './extensions';

export const removeTrackingLinkNodes = (initialEditorState: string) => {
  const editor = createEditor({
    namespace: 'MyEditor',
    nodes: [TrackingLinkNode],
  });

  editor.setEditorState(editor.parseEditorState(initialEditorState));

  editor.update(
    () => {
      const editorState = editor.getEditorState();
      editorState._nodeMap.forEach((node) => {
        if (node instanceof TrackingLinkNode) {
          node.replace($createTextNode(node.getTarget()));
        }
      });
    },
    { discrete: true }
  );

  return {
    text: editor.getEditorState().read(() => {
      const root = $getRoot();
      return root.getTextContent();
    }),
    richText: JSON.stringify(editor.getEditorState().toJSON()),
  };
};

export const getOriginalUrlFromTrackingLinkNodes = (initialEditorState: string) => {
  const editor = createEditor({
    namespace: 'MyEditor',
    nodes: [TrackingLinkNode],
  });

  editor.setEditorState(editor.parseEditorState(initialEditorState));

  const originalUrls: string[] = [];
  editor.read(() => {
    const editorState = editor.getEditorState();
    editorState._nodeMap.forEach((node) => {
      if (node instanceof TrackingLinkNode) {
        originalUrls.push(node.getTarget());
      }
    });
  });

  return originalUrls;
};
